import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Box, Typography } from "@material-ui/core";
import EditText from "../../components/EditText";
import Submit from "../../components/Submit";
import { useTranslation } from "react-i18next";

const validationSchema = Yup.object().shape({
  password: Yup.string().required("Is required"),
  confirm_password: Yup.string().required("Is required"),
});

const ResetConfirmForm = ({ initialValues, onSubmit = () => {} }) => {
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit}>
          <Box mb={1}>
            <Typography color="textPrimary" variant="h2">
              {t("reset_confirm.title")}
            </Typography>
          </Box>
          <Box mb={1}>
            <Typography>{t("reset_confirm.text")}</Typography>
          </Box>
          <EditText
            {...props}
            label={t("reset_confirm.password")}
            name="password"
            type="password"
          />
          <EditText
            {...props}
            label={t("reset_confirm.confirm_password")}
            name="confirm_password"
            type="password"
          />
          <Box my={2}>
            <Submit {...props} title={t("reset_confirm.button")} />
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default ResetConfirmForm;
